














































import Vue from 'vue'
import { tracefyOrange, tracefyOrangeDisabled } from '@/plugins/vuetify'
import { apiGetCalendarNotifications } from '@/api'
import { mutations } from '@/state'
import { Notification, monthsTranslationConverter } from '@/components/Notifications/constants'
import moment from 'moment-timezone'

export default Vue.extend({
  name: 'PlannedNotifications',
  data () {
    return {
      recentEntities: [],
      calendarModel: '',
      events: [],
      sentNotifications: [],
      selectedMonth: monthsTranslationConverter(moment.utc(new Date()).local().format('YYYY-MM-DD')),
      selectedYear: moment.utc(new Date()).local().format('YYYY'),
      tracefyOrangeDisabled,
      tracefyOrange
    }
  },
  methods: {
    eventHandler (e: { event: Notification }) {
      this.$emit('editNotification', e.event)
    },
    initialize () {
      apiGetCalendarNotifications(this.calendarModel).then(res => {
        this.events = res.data.data.map((e: Notification) => {
          const convertedDate = this.convertToLocal(e.start)
          return {
            ...e,
            start: convertedDate,
            end: convertedDate
          }
        })
        this.sentNotifications = [...this.events].filter((e) => e.sent_at).slice(-3)
      }).catch(e => { mutations.setSnackbar('error', e.response.data.message) })
    },
    convertToLocal (date: Date) {
      return moment(moment.utc(date).toDate()).local().format('YYYY-MM-DD HH:mm')
    }
  },
  mounted () {
    this.initialize()
  },
  watch: {
    calendarModel (val) {
      this.selectedMonth = monthsTranslationConverter(val)
      this.selectedYear = val.substr(0, 4)
    }
  }
})
